var Logger = require('core/utils/logger');
var cmabService = require('plugins/feature_cmab/cmabService');
var cmabApi = require('plugins/feature_cmab/cmabApi');
var cmabRum = require('plugins/feature_cmab/cmabRum');

exports.isCmabEnabled = function () {
  return __CMAB_IS_ENABLED__;
};

exports.isExperimentSyncApiEnabled = function (experiment: Experiment) {
  // Implement sync API call logic here.
  return __CMAB_IS_SYNC_API_CALL_ENABLED__;
};

exports.defaultToSnippetBucketing = function (experiment: Experiment, selectedVariationId: string, cmabUUID: string) {
  Logger.debug('CMAB / Defaulting to snippet bucketing with variation:', selectedVariationId, 'for experiment:', experiment.id);
  cmabService.setCmabVariationDataInVisitorStore(experiment, selectedVariationId, cmabUUID);
};

exports.processCmabExperiment = function (experiment: Experiment, selectedVariationId: string) {
  if (!exports.isCmabEnabled()) {
    Logger.debug('CMAB / Feature flag is disabled. Defaulting to snippet bucketing with variation:', selectedVariationId, 'for experiment:', experiment.id);
    return selectedVariationId;
  } else {
    Logger.debug('CMAB / Feature flag is enabled. Processing CMAB for experiment:', experiment.id);
  }

  cmabService.activateTimeoutForNonBucketedCmabExperiments(experiment);
  if (!cmabService.isCmabExperiment(experiment)) {
    return selectedVariationId;
  }

  var cmabVariationData = cmabService.getCmabVariationDataFromVisitorStore(experiment) as CmabVariationStorageData;
  if (!cmabService.isCmabTimeout(experiment, cmabVariationData)) {
    return cmabVariationData.variationId;
  }

  cmabRum.startCmabApiCallPerformanceTimer(experiment.id);

  var cmabVariationId = null;
  var cmabUUID = cmabService.generateCmabUUID();

  if (exports.isExperimentSyncApiEnabled(experiment)) {
    try {
      cmabVariationId = cmabApi.makeSyncApiCallWithXHR(experiment, cmabUUID);

      if (!cmabVariationId) {
        exports.defaultToSnippetBucketing(experiment, selectedVariationId, cmabUUID);
        cmabRum.endCmabApiCallPerformanceTimer(experiment.id);
        return selectedVariationId;
      }

      cmabService.setCmabVariationDataInVisitorStore(experiment, cmabVariationId, cmabUUID);

      cmabRum.endCmabApiCallPerformanceTimer(experiment.id);
      return cmabVariationId;
    } catch (error) {
      Logger.error('CMAB API / SYNC / API call failed with error:', error);
      exports.defaultToSnippetBucketing(experiment, selectedVariationId, cmabUUID);
      cmabRum.endCmabApiCallPerformanceTimer(experiment.id);
      return null;
    }
  }

  cmabApi.makeAsyncApiCall(experiment, cmabUUID).then(
    function (response) {
      cmabVariationId = cmabApi.handleCmabApiResponse(response, experiment);

      if (!cmabVariationId) {
        exports.defaultToSnippetBucketing(experiment, selectedVariationId, cmabUUID);
        cmabRum.endCmabApiCallPerformanceTimer(experiment.id);
        return selectedVariationId;
      }
      Logger.debug('CMAB API / ASYNC / Variation:', cmabVariationId, 'for experiment:', experiment.id);
      cmabService.setCmabVariationDataInVisitorStore(experiment, cmabVariationId, cmabUUID);
      cmabRum.endCmabApiCallPerformanceTimer(experiment.id);
      return cmabVariationId;
    },
    function (error) {
      Logger.error('CMAB API / ASYNC / API call failed with error:', error);
      exports.defaultToSnippetBucketing(experiment, selectedVariationId, cmabUUID);
      cmabRum.endCmabApiCallPerformanceTimer(experiment.id);
      return null;
    }
  );

  exports.defaultToSnippetBucketing(experiment, selectedVariationId, cmabUUID);
  cmabRum.endCmabApiCallPerformanceTimer(experiment.id);
  return selectedVariationId;
};

exports.getCmabUUIDAndUpdate30MinTimeout = function (layerId: string, experimentId: string): string {
  var cmabUUID = cmabService.getCmabUUIDFromVisitorStore(layerId, experimentId);
  cmabService.updateCmabTimeoutInVisitorStore(layerId, experimentId);
  return cmabUUID;
};
